import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["link", "className"];
import User from 'flarum/common/models/User';
import classList from 'flarum/common/utils/classList';
import RecipientLabel from './RecipientLabel';
export default function recipientsLabel(recipients, attrs) {
  if (attrs === void 0) {
    attrs = {};
  }
  const {
      link,
      className
    } = attrs,
    otherAttrs = _objectWithoutProperties(attrs, _excluded);
  otherAttrs.className = classList('RecipientsLabel', className);
  return m("span", otherAttrs, recipients == null ? void 0 : recipients.map((recipient, index) => {
    const type = recipient instanceof User ? 'u' : 'g';
    return m(RecipientLabel, {
      key: "".concat(type, "-").concat(index),
      recipient: recipient,
      link: link
    });
  }), !recipients && m(RecipientLabel, null));
}
flarum.reg.add('fof-byobu', 'forum/pages/labels/recipientsLabels', recipientsLabel);